export const SET_HRES3CU_INDEX_DISP = 'SET_HRES3CU_INDEX_DISP'
export const GET_HRES3CU_INDEX_DISP = 'GET_HRES3CU_INDEX_DISP'
export const SET_HRES3CU_DETAIL_DISP = 'SET_HRES3CU_DETAIL_DISP'
export const GET_HRES3CU_DETAIL_DISP = 'GET_HRES3CU_DETAIL_DISP'
export const GET_HRES3CU_DETAIL_TAB3_PROCESS = 'GET_HRES3CU_DETAIL_TAB3_PROCESS'
export const SET_HRES3CU_DETAIL_PROCESS_SELECTED = 'SET_HRES3CU_DETAIL_PROCESS_SELECTED'
export const SET_HRES3CU_DETAIL_PROCESS_DISP = 'SET_HRES3CU_DETAIL_PROCESS_DISP'
export const GET_HRES3CU_DETAIL_PROCESS_DISP = 'GET_HRES3CU_DETAIL_PROCESS_DISP'
export const GET_HRES3CU_DETAIL_PROCESS_POPUP = 'GET_HRES3CU_DETAIL_PROCESS_POPUP'
export const SET_HRES3CU_DETAIL_PROCESS_POPUP = 'SET_HRES3CU_DETAIL_PROCESS_POPUP'
export const SET_HRES3CU_MAX_ROWSPAN = 'SET_HRES3CU_MAX_ROWSPAN'
export const GET_HRES3CU_MAX_ROWSPAN = 'GET_HRES3CU_MAX_ROWSPAN'
export const SET_HRES3CU_COLUMNS = 'SET_HRES3CU_COLUMNS'
export const GET_HRES3CU_COLUMNS = 'GET_HRES3CU_COLUMNS'
export const SET_HRES3CU_LABELS = 'SET_HRES3CU_LABELS'
export const GET_HRES3CU_LABELS = 'GET_HRES3CU_LABELS'
export const RECEIVED_HRES3CU_COLUMNS_LABELS = 'RECEIVED_HRES3CU_COLUMNS_LABELS'
export const SET_HRES3CU_INDEX = 'SET_HRES3CU_INDEX'
export const GET_HRES3CU_INDEX = 'GET_HRES3CU_INDEX'
export const RECEIVED_HRES3CU_INDEX = 'RECEIVED_HRES3CU_INDEX'
export const SET_HRES3CU_INDEX_SELECTED = 'SET_HRES3CU_INDEX_SELECTED'
export const GET_HRES3CU_INDEX_SELECTED = 'GET_HRES3CU_INDEX_SELECTED'
export const SET_HRES3CU_DETAIL = 'SET_HRES3CU_DETAIL'
export const GET_HRES3CU_DETAIL = 'GET_HRES3CU_DETAIL'
export const SET_HRES3CU_DETAIL_PROCESS = 'SET_HRES3CU_DETAIL_PROCESS'
export const GET_HRES3CU_DETAIL_PROCESS = 'GET_HRES3CU_DETAIL_PROCESS'
export const RECEIVED_HRES3CU_DETAIL = 'RECEIVED_HRES3CU_DETAIL'
export const RECEIVED_HRES3CU_DETAIL_PROCESS = 'RECEIVED_HRES3CU_DETAIL_PROCESS'
export const TOGGLE_HRES3CU_PAGE = 'TOGGLE_HRES3CU_PAGE'
export const POST_HRES3CU_DETAIL_PROCESS = 'POST_HRES3CU_DETAIL_PROCESS'
export const POST_HRES3CU_DETAIL_PROCESS_POPUP = 'POST_HRES3CU_DETAIL_PROCESS_POPUP'
export const RECEIVED_HRES3CU_DETAIL_PROCESS_POPUP_CREATE = 'RECEIVED_HRES3CU_DETAIL_PROCESS_POPUP_CREATE'
export const RECEIVED_HRES3CU_DETAIL_PROCESS_POPUP = 'RECEIVED_HRES3CU_DETAIL_PROCESS_POPUP'



// WEBPACK FOOTER //
// ./src/store/modules/hres3cu/mutation-types.js